import adminApi from "services/admin-api";

export const workspaceAccountService = {
  notifications: {
    list: adminApi.notifications.list,
    read: adminApi.notifications.read,
    readAll: adminApi.notifications.readAll,
    remove: adminApi.notifications.remove,
  },
  requests: {
    available: adminApi.requests.available,
    cancel: adminApi.requests.cancel,
    create: adminApi.requests.create,
    fulfill: adminApi.requests.fulfill,
    list: adminApi.requests.list,
  },
  users: {
    followAthlete: adminApi.users.followAthlete,
    followedAthletes: adminApi.users.followedAthletes,
    list: adminApi.users.list,
    unfollowAthlete: adminApi.users.unfollowAthlete,
  },
};
